module.exports = __webpack_public_path__ + "static/media/githubIcon.aeda9fa1.svg";